import axiosInstance from '../services/AxiosInstance';

export function getListingTypes(pageNum = 1, pageSize = 10, searchTerm = "", filterQuery = "") {
    return axiosInstance.get(`listing-type?pageNum=${pageNum}&pageSize=${pageSize}&search=${searchTerm}`);
}

export function deleteListingType(id) {
    return axiosInstance.delete(`listing-type/${id}`);
}

export function createListingType(id) {
    return axiosInstance.post(`listing-type`,id);
}

export function updateListingType(id, data) {
    return axiosInstance.put(`listing-type/${id}`,data);
}
